// extracted by mini-css-extract-plugin
module.exports = {"block":"SchoolRankings_block__H4SgB","stat":"SchoolRankings_stat__CRJfS"};